import { useState } from "react";
import { QrCode } from "lucide-react";

/** QR da tavolo: se indichi il numero, il cliente non deve più scegliere il tavolo. */
export const QrTavolo = ({ slug }) => {
  const [tav, setTav] = useState("");
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/public/kit/tavolo.pdf?slug=${slug}` +
    (tav.trim() ? `&tavolo=${encodeURIComponent(tav.trim())}&nome=${encodeURIComponent("Tavolo " + tav.trim())}` : "");
  return (
    <div className="flex flex-wrap items-center gap-3">
      <input
        className="h-12 w-40 rounded-md border border-slate-200 px-3 text-sm"
        placeholder="Numero tavolo (facoltativo)"
        value={tav}
        onChange={(e) => setTav(e.target.value)}
        data-testid="qr-tavolo-numero"
      />
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="inline-flex h-12 items-center rounded-md bg-amber-500 px-6 text-sm font-bold text-slate-950 hover:bg-amber-400"
        data-testid="tavolo-pdf-link"
      >
        <QrCode className="mr-2 h-4 w-4" /> Scarica il QR da tavolo
      </a>
    </div>
  );
};
